import { Chat, theme } from '@/config'
import { createStyles } from '@codeleap/styles'
import { Avatar, View, Text, UserDetailsModal, ActionIcon } from '@/components'
import { useChannelStateContext } from 'stream-chat-react'
import { Getstream } from '@/services'
import { Medias } from '@/config/packages'

export const ThreadHeader = () => {
  const { thread } = useChannelStateContext()
  const { closeThread } = Getstream.Chat.useThreadNavigation()
  const { selectModeActive } = Chat.Store.useSelectMode({ threadList: true })
  const user = thread?.user
  const { src: userImage } = Medias.useResolvedUrl(user?.image as string)

  const handlePress = () => {
    UserDetailsModal.open({ user })
  }

  const handleBack = () => {
    closeThread()
  }

  return (
    <View style={styles.wrapper}>
      {!selectModeActive && (
        <ActionIcon
          icon='chevron-left'
          onPress={handleBack}
          style={['large', 'minimal', 'normalize']}
        />
      )}

      <View onClick={handlePress} style={['gap:1', 'row']}>
        <Avatar
          debugName=''
          image={userImage as any}
          name={user?.name}
          firstNameOnly={false}
          style={'chatHeader'}
        />

        <View style={['column', 'alignStart', 'justifyCenter']}>
          <Text style={['p2', { color: theme.colors.textHeadingHighlighted }]} text={'Reply with thread'} />
          <Text style={['c2', { color: theme.colors.textCaption }]} text={user?.name} />
        </View>
      </View>
    </View>
  )
}

const styles = createStyles(theme => ({
  wrapper: {
    ...theme.presets.alignCenter,
    ...theme.presets.justifyStart,
    ...theme.presets.fullWidth,
    ...theme.presets.row,
    gap: theme.spacing.value(2),
    ...theme.spacing.padding(3),
  },
}))
